import styled from 'styled-components'
import { Button, Flex, TelegramIcon, Text, TwitterIcon } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'
import useTheme from 'hooks/useTheme'
import { palette } from '../colors'

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 40px 16px 80px;
`

const Card = styled.div<{ $gradient: string } & React.HTMLAttributes<HTMLDivElement>>`
  width: 100%;
  max-width: 1280px;
  border-radius: 28px;
  padding: 56px 24px;
  background: ${({ $gradient }) => $gradient};
  box-shadow: 0 24px 64px rgba(10, 26, 51, 0.32);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;
  color: #fff;

  ${({ theme }) => theme.mediaQueries.md} {
    padding: 80px 60px;
    border-radius: 32px;
  }
`

const Eyebrow = styled.span`
  font-family: 'Geist Mono', monospace;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 2px;
  color: rgba(242, 246, 252, 0.7);
`

const Title = styled.h2`
  font-size: 36px;
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -1px;
  color: #fff;
  margin: 0;

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 48px;
    letter-spacing: -1.5px;
  }
`

const Sub = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: rgba(242, 246, 252, 0.8);
  max-width: 560px;
  margin: 0;
`

const SocialBtn = styled(Button)`
  background: #fff;
  color: #0a1a33;
  border-radius: 12px;
  padding: 12px 22px;
  font-weight: 600;
  font-size: 15px;
  height: auto;
  &:hover {
    background: #fff !important;
    filter: brightness(0.95);
  }
`

const Footer: React.FC<React.PropsWithChildren> = () => {
  const { t } = useTranslation()
  const { theme } = useTheme()
  const p = palette(theme.isDark)
  const gradient = `linear-gradient(225deg, ${p.cobaltDeep} 0%, ${p.cobalt} 60%, ${p.cyan} 100%)`

  return (
    <Wrapper>
      <Card $gradient={gradient}>
        <Eyebrow>COMMUNITY</Eyebrow>
        <Title>{t('Join our social community')}</Title>
        <Sub>{t('Keep up with the newest news, updates, AMAs, governance and giveaways.')}</Sub>
        <Flex style={{ gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
          <SocialBtn as="a" href="https://x.com/qomswap1" target="_blank" rel="noreferrer">
            <TwitterIcon color="currentColor" mr="8px" />
            Twitter
          </SocialBtn>
          <SocialBtn as="a" href="https://t.me/+J4Wk4HzLE701MzU0" target="_blank" rel="noreferrer">
            <TelegramIcon color="currentColor" mr="8px" />
            Telegram
          </SocialBtn>
        </Flex>
      </Card>
    </Wrapper>
  )
}

export default Footer
